import * as React from "react";
const SvgAcornAppQrCode = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 1140 1140", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#FFF", d: "M0 0h1147v1147H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 62)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 62)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 62)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 62)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 62)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 62)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 62)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 62)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 93)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 93)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 93)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 93)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 93)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 124)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 124)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 124)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 124)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 124)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 124)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 124)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 155)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 155)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 155)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 155)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 155)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 155)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 155)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 155)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 155)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 155)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 186)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 186)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 186)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 186)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 186)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 186)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 186)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 186)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 186)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 217)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 217)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 217)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 217)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 217)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 217)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 217)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 248)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 248)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 248)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 248)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 248)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 248)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 248)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 248)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 248)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 279)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 62 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 186 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 248 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 899 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1054 310)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 62 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 155 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 186 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 992 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 341)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 62 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 186 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 217 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 248 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 372)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 124 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 186 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 217 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1054 403)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 93 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 124 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 186 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 248 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1054 434)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 62 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 465)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 186 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 217 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 248 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 899 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 992 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 496)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 93 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 124 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 155 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 217 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 527)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 248 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 558)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 124 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 155 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 186 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 992 589)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 248 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 899 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 620)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 62 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 155 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 899 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1054 651)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 93 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 155 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 186 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 248 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 682)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 62 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 186 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 899 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 713)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 124 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 186 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 248 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 744)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 124 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 155 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 217 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 899 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 775)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 62 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 93 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 124 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 217 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 248 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 279 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 899 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1054 806)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 992 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 837)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1023 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 899)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 899)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 899)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 899)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 899)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 899)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 899)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 899 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1054 930)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 899 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 961 961)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 992)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 992)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 992)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 558 992)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 992)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 837 992)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 992)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 899 992)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 930 992)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 992 992)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 403 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 496 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 620 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 651 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 1023)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 310 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 341 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 372 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 434 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 465 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 527 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 589 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 682 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 713 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 744 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 775 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 806 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 868 1054)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.31 0 0 .31 1054 1054)" }), /* @__PURE__ */ React.createElement("g", { style: {
  fill: "#000"
} }, /* @__PURE__ */ React.createElement("path", { d: "M15 15h70v70H15z", style: {
  fill: "none"
}, transform: "matrix(2.17 0 0 2.17 62 62)" }), /* @__PURE__ */ React.createElement("path", { d: "M246.45 62H62v217h217V62h-32.55zm0 184.45H94.55V94.55h151.9v151.9z" })), /* @__PURE__ */ React.createElement("g", { style: {
  fill: "#000"
} }, /* @__PURE__ */ React.createElement("path", { d: "M15 15h70v70H15z", style: {
  fill: "none"
}, transform: "matrix(2.17 0 0 2.17 868 62)" }), /* @__PURE__ */ React.createElement("path", { d: "M1052.45 62H868v217h217V62h-32.55zm0 184.45h-151.9V94.55h151.9v151.9z" })), /* @__PURE__ */ React.createElement("g", { style: {
  fill: "#000"
} }, /* @__PURE__ */ React.createElement("path", { d: "M15 15h70v70H15z", style: {
  fill: "none"
}, transform: "matrix(2.17 0 0 2.17 62 868)" }), /* @__PURE__ */ React.createElement("path", { d: "M246.45 868H62v217h217V868h-32.55zm0 184.45H94.55v-151.9h151.9v151.9z" })), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.93 0 0 .93 124 124)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.93 0 0 .93 930 124)" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h100v100H0z", style: {
  fill: "#000"
}, transform: "matrix(.93 0 0 .93 124 930)" }));
export default SvgAcornAppQrCode;
